import { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error('Complete los campos obligatorios'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success('Mensaje enviado correctamente');
      setForm({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch {
      toast.error('Error al enviar el mensaje');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <Badge variant="secondary" className="mb-4">Contacto</Badge>
          <h1 className="text-4xl sm:text-5xl font-display font-semibold tracking-tight mb-4">Contáctanos</h1>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">Estamos disponibles para atender tus consultas, cotizaciones y requerimientos técnicos.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Nombre *</Label>
                <Input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Tu nombre" data-testid="contact-name" />
              </div>
              <div className="space-y-2">
                <Label>Correo *</Label>
                <Input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="correo@ejemplo.com" data-testid="contact-email" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Teléfono</Label>
                <Input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="+52 55..." />
              </div>
              <div className="space-y-2">
                <Label>Asunto</Label>
                <Input value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} placeholder="Asunto" />
              </div>
            </div>
            <div className="space-y-2">
              <Label>Mensaje *</Label>
              <textarea
                value={form.message}
                onChange={e => setForm({...form, message: e.target.value})}
                placeholder="Escribe tu mensaje..."
                rows={5}
                className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                data-testid="contact-message"
              />
            </div>
            <Button type="submit" disabled={loading} className="gap-2" data-testid="contact-submit">
              <Send className="h-4 w-4" /> {loading ? 'Enviando...' : 'Enviar Mensaje'}
            </Button>
          </form>

          <div className="space-y-6">
            <Card>
              <CardContent className="p-6 space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0 text-muted-foreground" />
                  <div>
                    <h3 className="font-display font-semibold text-sm mb-1">Dirección</h3>
                    <p className="text-sm text-muted-foreground">Presa Tepuxtepec No. 40-E, Col. Lomas Hermosa, Alcaldía Miguel Hidalgo, CP 11200 Ciudad de México</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Phone className="h-5 w-5 mt-0.5 flex-shrink-0 text-muted-foreground" />
                  <div>
                    <h3 className="font-display font-semibold text-sm mb-1">Teléfonos</h3>
                    <p className="text-sm text-muted-foreground" data-testid="contact-phone-tienda">
                      <span className="font-medium text-foreground">Atención de tienda:</span> <a href="tel:+525514541198" className="hover:text-foreground transition-colors">+52 55 1454 1198</a>
                    </p>
                    <p className="text-sm text-muted-foreground mt-1" data-testid="contact-phone-mesa">
                      <span className="font-medium text-foreground">Mesa de ayuda:</span> <a href="tel:+525572526051" className="hover:text-foreground transition-colors">+52 55 7252 6051</a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Mail className="h-5 w-5 mt-0.5 flex-shrink-0 text-muted-foreground" />
                  <div>
                    <h3 className="font-display font-semibold text-sm mb-1">Correo</h3>
                    <p className="text-sm text-muted-foreground">info@kindtechnologies.net</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
